<!--
  ~ QUEST SOFTWARE PROPRIETARY INFORMATION
  ~
  ~ This software is confidential.  Quest Software Inc., or one of its
  ~ subsidiaries, has supplied this software to you under terms of a
  ~ license agreement, nondisclosure agreement or both.
  ~
  ~ You may not copy, disclose, or use this software except in accordance with
  ~ those terms.
  ~
  ~
  ~ Copyright 2026 Quest Software Inc.
  ~ ALL RIGHTS RESERVED.
  ~
  ~ QUEST SOFTWARE INC. MAKES NO REPRESENTATIONS OR
  ~ WARRANTIES ABOUT THE SUITABILITY OF THE SOFTWARE,
  ~ EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
  ~ TO THE IMPLIED WARRANTIES OF MERCHANTABILITY,
  ~ FITNESS FOR A PARTICULAR PURPOSE, OR
  ~ NON-INFRINGEMENT.  QUEST SOFTWARE SHALL NOT BE
  ~ LIABLE FOR ANY DAMAGES SUFFERED BY LICENSEE
  ~ AS A RESULT OF USING, MODIFYING OR DISTRIBUTING
  ~ THIS SOFTWARE OR ITS DERIVATIVES.
  -->

<div class="sale-support-container" [ngClass]="theme">
  <div class="support-text">Sales & Support</div>
  <div class="support-options-display">
    <div class="request-support-width">
      <fac-action-link 
        [type]="actionLinkType.GO_TO_LINK"
        [label]="'Request Support'"
        [facTooltip]="null"
        (click)="supportOnClick()">
      </fac-action-link>
    </div>

    <div class="contact-sales-width">
      <fac-action-link 
        [type]="actionLinkType.GO_TO_LINK"
        [label]="'Contact Sales'"
        [facTooltip]="
            !isOwnerOrAdmin
              ? 'Only Cloud Owner or Cloud Administrator can purchase a subscription'
              : ''
          "
        [disabled]="!isOwnerOrAdmin"
        (click)="salesOnClick()">
      </fac-action-link>
    </div>
  </div>
</div>
